






















import { Component, Prop, Vue } from "vue-property-decorator";
import Header from "@/commonComponents/header/header.vue";
import PagePreview from "./pagePreview/pagePreview.vue";
import TopController from "./topController/topController.vue";
import RightController from "./rightController/rightController.vue";
import PageController from '@/commonComponents/pageController/pageController.vue';
import ColorPicker from "@/commonComponents/colorPicker/colorPicker.vue";
import PrintLoading from "./printLoading/printLoading.vue"
import Tutorial from "../tutorial/tutorial.vue";
import License from "../top2/mainContents/license/license.vue";
import LoadingScreen from "@/commonComponents/loadingScreen/loadingScreen.vue"

import * as def from "@/definitions";
import { Const } from '@/const';
// TODO document2
import { Document } from "@/model/document2/document";
import { Page } from "@/model/document2/page/page";
import { Surface } from '@/model/document2/page/surface/surface';
import { Design } from "@/model/document2/page/surface/design/design";
import { Layer } from '@/model/document2/page/surface/design/layer/layer'
import { UserConfig } from '@/model/userConfig/userConfig';
import { ColorConstruct } from "@/utilityModels/colorConstruct";
import { Rectangle } from '@/utilityModels/rectangle';

// Helper
import { FileHelper } from "@/helper/fileHelper";
import { LogHelper } from "@/helper/logHelper";
import { RequestHelper } from '@/helper/requestHelper';
import { InsertionHelper } from '@/helper/insertionHelper';
import { NameHelper } from "@/helper/nameHelper"
import { UserAgentHelper } from "@/helper/userAgentHelper"
import { ResourceHelper } from "@/helper/resourceHelper"
import { DocumentHelper } from '@/helper/documentHelper';
import { DebugHelper } from "@/helper/debugHelper";
import { CookieHelper } from "@/helper/cookieHelper";
import { UnitHelper } from "@/helper/unitHelper";
import { NativeHelper } from '@/helper/nativeHelper';
import { MathHelper } from '@/helper/mathHelper';

import printJS from 'print-js';

import PopupController from "./_mobile/popupController/popupController.vue";

@Component({
  components: {
    Header,
    PagePreview,
    TopController,
    RightController,
    PageController,
    ColorPicker,
    PrintLoading,
    Tutorial,
    License,
    LoadingScreen,
    PopupController
  }
})

// 印刷設定
//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class PrintSetting extends Vue
{
    // ドキュメントのロード終了フラグ
    // モバイルではこのフラグがオンになるまでは表示させない
    private isLoadedDocument = false;

    // モバイル用コントローラ
    private popupControllerType = "none";

    // モバイル用コントローラ表示
    private showPopupController(controller : string)
    {
        this.popupControllerType = controller;
    }

    // プリントレコメンド
    // 印刷コンテンツ作成中
    private isCreatingPrintContent = false;
    // レコメンドタイマー起動中
    private isRunningPrintLoadingTimer = false;
    private get loading()
    {
        if (process.env.VUE_APP_ADVERTISEMENT_BEFORE_PRINT === 'yes') {
            return this.isCreatingPrintContent || this.isRunningPrintLoadingTimer;
        } else {
            return this.isCreatingPrintContent;
        }
    }
    isPrintConfirmationForIEVisible = false

    private get currentTab() { return "/PrintSetting"; }

    private get paperInfoText() { return DocumentHelper.getPaperInfoText(this.currentDocument); }

    // ズーム
    private zoomScale: number = 100;
    private isAutoZoom: boolean = true;

    // チュートリアルフラグ
    isTutorial = false;
    // 使用規約許諾フラグ
    isLicense = false;

    // 待機
    private isWaiting = false;
    private get waitingTitle() { return "処理中"; }
    private get waitingMessage() { return "処理をしています…"; }

    // ヘッダーで画面から抜ける時の処理
    private onHeaderNavigationStart(link : string)
    {
        if(link == "/DesignEditor" || link == "/LayoutEditor")
        {
            // デザイン、レイアウトに遷移する時に処理中表示
            this.isWaiting = true;
        }
    }

    private onHeaderNavigationFinish(link : string)
    {
        // 処理中を非表示
        this.isWaiting = false;
    }

    // 遷移処理
    // showWait : 待機モーダルを表示する
    private goLink(link : string, showWait : boolean = false)
    {
        if(showWait)
        {
            this.isWaiting = true;
            setTimeout(() =>
            {
                this.isWaiting = false;
                this.$router.push(link);
            }, 50);
        }
        else
        {
            this.$router.push(link);
        }
    }

    private mounted()
    {
        // メッセージセンター登録
        var messageCenter = this.$store.getters.messageCenter;
        messageCenter.subscribe(this, "exec_command", this.processExecCommand);

        if(CookieHelper.getItem("license") != true){
            this.isLicense = true;
        }
        else if(CookieHelper.getItem("printSettingTutorial") != true){
            this.isTutorial = true;
        }

        var param = {};
        param["view"] = "PrintSetting";
        NativeHelper.sendNativeEvent("view_mounted", param);

        // 印刷データのクリア
        this.$store.getters.userConfig.exportedPDF = "";
    }

    private destroyed()
    {
        // メッセージセンター削除
        var messageCenter = this.$store.getters.messageCenter;
        messageCenter.unsubscribe(this, "exec_command");

        // 印刷データのクリア
        this.$store.getters.userConfig.exportedPDF = "";
    }

    // コマンド処理
    private processExecCommand(param : any)
    {
        try
        {
            var command : string = param.command;
            var parameter : any = param.parameter;

            if(command == "import_document")
            {
                // ドキュメント読み込み
                try
                {
                    var json = parameter.document;
                    var jsonData = JSON.parse(json);
                    var importDocument = Document.createFromJsonData(jsonData);
                    if(importDocument.useInsertion)
                    {
                        // 差し込みは読み込まない
                        NativeHelper.sendNativeEvent("import_document_error", { about : "useInsertion" });
                        return;
                    }
                    this.$store.dispatch("setDocument", importDocument);
                    // 読み込み完了フラグON *少し遅延させないと画像読み込みが遅れる
                    setTimeout(() =>
                    {
                        this.isLoadedDocument = true;
                    }, 100);
                }
                catch(eDoc)
                {
                    // ドキュメント読み込み独自でエラーチェックする
                    NativeHelper.sendNativeEvent("import_document_error", { about : "invalid" });
                }
            }
            else if(command == "export_print_pdf")
            {
                // pdf作成
                var code = parameter != null && parameter.code != null ? parameter.code : "";
                // 印刷用パラメータ
                if(parameter != null) 
                {
                    // 開始ページ
                    if(parameter.startPage != null) { this.setPrintStartPage(Number(parameter.startPage)); }
                    // 終了ページ
                    if(parameter.endPage != null) { this.setPrintEndPage(Number(parameter.endPage)); }
                    // 両面印刷
                    if(parameter.doubleSides != null) 
                    { 
                        if(parameter.doubleSides == "1") { this.printDoubleSides(); }
                        else { this.changeSurface(this.currentDocument.isReverseSurface); }
                    }
                    // 反転印刷
                    if(parameter.flip != null) { this.setPrintFlip(parameter.flip == "1"); }
                    // 枠あり印刷
                    if(parameter.border != null) { this.setPrintBorderVisible(parameter.border == "1"); }
                    // 印刷位置(縦)
                    if(parameter.verticalPosition != null)
                    {
                        var pos = Number(parameter.verticalPosition);
                        if(pos < 0)
                        {
                            this.changePrintVerticalDirection("up", false);
                            this.changePrintVerticalDirection("up", true);
                            this.setVerticalPosition(-pos, false);
                            this.setVerticalPosition(-pos, true);
                        }
                        else
                        {
                            this.changePrintVerticalDirection("down", false);
                            this.changePrintVerticalDirection("down", true);
                            this.setVerticalPosition(pos, false);
                            this.setVerticalPosition(pos, true);
                        }
                    }
                    if(parameter.verticalPositionReverse != null)
                    {
                        var pos = Number(parameter.verticalPositionReverse);
                        if(pos < 0)
                        {
                            this.changePrintVerticalDirection("up", true);
                            this.setVerticalPosition(-pos, true);
                        }
                        else
                        {
                            this.changePrintVerticalDirection("down", true);
                            this.setVerticalPosition(pos, true);
                        }
                    }
                    // 印刷位置(横)
                    if(parameter.horizontalPosition != null)
                    {
                        var pos = Number(parameter.horizontalPosition);
                        if(pos < 0)
                        {
                            this.changePrintHorizontalDirection("left", false);
                            this.changePrintHorizontalDirection("left", true);
                            this.setHorizontalPosition(-pos, false);
                            this.setHorizontalPosition(-pos, true);
                        }
                        else
                        {
                            this.changePrintHorizontalDirection("right", false);
                            this.changePrintHorizontalDirection("right", true);
                            this.setHorizontalPosition(pos, false);
                            this.setHorizontalPosition(pos, true);
                        }
                    }
                    if(parameter.horizontalPositionReverse != null)
                    {
                        var pos = Number(parameter.horizontalPositionReverse);
                        if(pos < 0)
                        {
                            this.changePrintHorizontalDirection("left", true);
                            this.setHorizontalPosition(-pos, true);
                        }
                        else
                        {
                            this.changePrintHorizontalDirection("right", true);
                            this.setHorizontalPosition(pos, true);
                        }
                    }
                    // サイズ調整
                    if(parameter.scale != null) { this.setPrintRate(Number(parameter.scale)); }
                }
                this.createPdfFromPages(false, code);
            }
            else if(command == "change_printable")
            {
                // 印刷切り替え
                this.changePrintable();
            }
            else if(command == "reverse_surface")
            {
                // 面を逆にする
                if(this.currentDocument.hasReverseSurface)
                {
                    this.changeSurface(!this.currentDocument.isReverseSurface);
                }
            }
            else if(command == "next_page")
            {
                // 次のページへ
                this.goPage(this.currentDocument.currentPageIndex + 1);
            }
            else if(command == "back_page")
            {
                // 前のページへ
                this.goPage(this.currentDocument.currentPageIndex - 1);
            }
            else if(command == "show_popup_controller")
            {
                // コントローラの表示制御
                var controller = parameter.controller;
                this.showPopupController(controller);
            }
            else if(command == "change_print_setting")
            {
                // 印刷設定変更
                if(parameter != null)
                {
                    for(var key in parameter)
                    {
                        if(key == "borderColor")
                        {
                            // 枠線の色
                            var borderColor = ColorConstruct.createFromHex(parameter[key]);
                            this.borderColor = borderColor;
                        }
                    }
                }
            }
        }
        catch(ex)
        {
            DebugHelper.trace(ex);
        }
    }

    private get currentDocument(): Document
    {
        return this.$store.getters.document;
    }

    private get pageList() : Array<Page>
    {
        var document = this.currentDocument;
        if(document.useInsertion)
        {
            // 印刷設定のページを取得
            return InsertionHelper.createPageList(document, true);
        }
        else
        {
            return document.pageList;
        }
    }

    private get currentPage(): Page
    {
        var document = this.currentDocument;
        return this.pageList[document.currentPageIndex];
    }

    private get isReverseSurface()
    {
        var document = this.currentDocument;
        return document.isReverseSurface;
    }

    public get currentPageNumber(): number
    {
        return this.currentDocument.currentPageIndex + 1;
    }

    private get userConfig() : UserConfig
    {
        return this.$store.getters.userConfig;
    }
    // 印刷部数
    private paperNumber: number = 1;
    // 開始ページ
    private printStartPage: number = 1;
    // 終了ページ
    private printEndPage: number = this.pageList.length;
    // 印刷倍率(%)
    private get printRate() { return this.userConfig.printRate; }
    // 反転印刷
    private get isPrintFlip() { return this.userConfig.isPrintFlip; }
    // 枠あり印刷
    private get isBorderVisible() { return this.userConfig.isPrintBorder; }
    // 枠の色
    private static readonly UNSELECTED_BORDER_COLOR = new ColorConstruct(151, 151, 151);
    private borderColorRgb = this.$store.getters.userConfigColors.buttonColorRgb;
    private borderColor: ColorConstruct = new ColorConstruct( this.borderColorRgb.r, this.borderColorRgb.g, this.borderColorRgb.b );
    private get borderWidthPreview()
    {
        return this.isBorderVisible ? 2 : 1;
    }
    // 枠色ピッカー表示フラグ
    private isBorderColorPickerVisible = false;
    // 枠色ピッカーの場所
    private pickerLeft: number = 0;
    private pickerTop: number = 0;
    private get pickerStyle() {
        return {
            position: "absolute",
            left: this.pickerLeft + "px",
            top: this.pickerTop + "px",
            zIndex: 10
        };
    }
    private get bleedSize() { return this.$store.getters.userConfig.bleedSize; }
    private get documentRotate() { return this.currentDocument.rotate; }

    // 印刷ページ数
    private get printPageCount()
    {
        return this.printEndPage - this.printStartPage + 1;
    }

    // 空フレーム数のカウント
    // オブジェクトが存在していない場合は空フレームにカウントする
    private get blankFrameCount()
    {
        var count = 0;
        for(var pageIndex = this.printStartPage - 1; pageIndex <= this.printEndPage - 1; ++pageIndex)
        {
            var page = this.pageList[pageIndex];
            for(var designIndex = 0; designIndex < page.designMaxNumber; ++designIndex)
            {
                var design = page.getSurface(this.isReverseSurface).getDesign(designIndex);
                if(design == null || !design.hasAnyObject())
                {
                    count++;
                }
            }
        }
        return count;
    }

    // すべてのドキュメントへの編集は、このクラスから行う
    // action - mutation モデルへの移行も視野に入れている

    // コマンドのコール
    private onDoCommand(command: string, parameter: any)
    {
        if (command == "savePDF")
        {
            // PDF保存
            this.savePDF();
        }
        else if (command == "saveDocument")
        {
            // document保存
            this.saveDocument();
        }
        else if (command == "print")
        {
            if(UserAgentHelper.getBrowser() == "ie"){
                this.isPrintConfirmationForIEVisible = true
            }else{
                // 印刷
                this.print();
            }

        }
        else if (command == "changeSurface")
        {
            // 面変更
            this.changeSurface(parameter.isReverse);
        }
        else if(command == "printDoubleSides")
        {
            // 両面印刷
            this.printDoubleSides();
        }
        else if (command == "goPage")
        {
            // ページ変更
            this.goPage(parameter.page);
        }
        else if (command == "setPaperNumber")
        {
            // 印刷部数変更
            this.setPaperNumber(parameter.paperNumber);
        }
        else if (command == "setPrintStartPage")
        {
            // 開始ページ変更
            this.setPrintStartPage(parameter.page);
        }
        else if (command == "setPrintEndPage")
        {
            // 終了ページ変更
            this.setPrintEndPage(parameter.page);
        }
        else if (command == "setVerticalPosition")
        {
            // 位置調整 : 縦
            this.setVerticalPosition(parameter.position, parameter.isReverse);
        }
        else if (command == "setHorizontalPosition")
        {
            // 位置調整 : 横
            this.setHorizontalPosition(parameter.position, parameter.isReverse);
        }
        else if (command == "setPrintRate")
        {
            // 印刷倍率
            this.setPrintRate(parameter.rate);
        }
        else if (command == "setPrintFlip")
        {
            // 反転印刷
            this.setPrintFlip(parameter.isFlip);
        }
        else if (command == "setPrintBorderVisible")
        {
            // 枠あり印刷
            this.setPrintBorderVisible(parameter.isVisible);
        }
        else if (command == "changePrintVerticalDirection")
        {
            this.changePrintVerticalDirection(parameter.direction, parameter.isReverse);
        }
        else if (command == "changePrintHorizontalDirection")
        {
            this.changePrintHorizontalDirection(parameter.direction, parameter.isReverse);
        }
        else if (command == "setVisibleBorderColorPicker")
        {
            // 枠色ピッカー表示
            this.setVisibleBorderColorPicker(parameter.left, parameter.top);
        }
        else if (command == "closeBorderColorPicker")
        {
            // 枠色ピッカー非表示
            this.onCloseColorPicker();
        }
        else if (command == "changePrintable")
        {
            // 印刷可能切り替え
            this.changePrintable();
        }
        else if (command == "changeZoomScale")
        {
            // ズーム倍率変更
            var isAutoZoomOff =
                parameter.isAutoZoomOff != null ? parameter.isAutoZoomOff : false;
            this.changeZoomScale(parameter.scale, isAutoZoomOff);
        }
        else if (command == "changeAutoZoom")
        {
            // 自動ズーム切り替え
            this.changeAutoZoom(parameter.isAutoZoom);
        }
        else if(command == "changeBorderColor")
        {
            // Mobile:  枠色変更
            this.borderColor = parameter.color;
        }
        else if(command == "sendNativeEvent")
        {
            // Mobile: ネイティブイベントを呼び、ネイティブ側に通知する
            NativeHelper.sendNativeEvent(parameter.message, parameter.parameter);
        }
    }

    // 色変更中
    private onChangingColor(color) {
        this.borderColor = color;
    }

    // 色変更完了
    private onChangedColor(color) {
        this.borderColor = color;
    }

    // カラーピッカー閉じる
    private onCloseColorPicker() {
        this.isBorderColorPickerVisible = false;
    }

    // PDF保存
    private savePDF()
    {
        this.createPdfFromPages(false);
        this.sendSavePDFLog();
    }

    // 履歴送信
    private sendSavePDFLog()
    {
        var logValue = {
            productId : this.currentDocument.productId,
            code : this.currentDocument.paperCode
        }

        var applicationState = this.$store.getters.applicationState;
        var actionCode = applicationState.flowMode == 0 ? "905" : "915";

        LogHelper.sendLog(actionCode, logValue);
    }

    // 印刷ファイル保存
    private saveDocument()
    {
        // 開いた時のファイル名があればそれを使う
        var fileName = this.currentDocument.openedFileName != "" ? FileHelper.getFilenameWithoutExtension(this.currentDocument.openedFileName) : NameHelper.createNewDocumentFileName(this.currentDocument);
        FileHelper.saveDocument(this.currentDocument, fileName);
        this.sendSaveLog();
    }

    // 履歴送信
    private sendSaveLog()
    {
        var logValue = {
            productId : this.currentDocument.productId,
            code : this.currentDocument.paperCode,
            templateId : this.$store.getters.data.selectedTemplate.id,
            cloud : 0
        }

        LogHelper.sendLog("1000", logValue);
    }

    // 印刷
    private print()
    {
        this.createPdfFromPages(true);
        this.sendPrintLog();
    }

    // 履歴送信
    private sendPrintLog()
    {
        var pageCount = this.printEndPage - this.printStartPage + 1;

        var logValue = {
            page : pageCount,
            productId : this.currentDocument.productId,
            code : this.currentDocument.paperCode
        }

        var applicationState = this.$store.getters.applicationState;
        var actionCode = applicationState.flowMode == 0 ? "900" : "910";

        LogHelper.sendLog(actionCode, logValue);
    }

    private changeSurface(isReverse: boolean)
    {
        // アンドゥ・リドゥの対象外
        this.currentDocument.setSurface(isReverse);
        // 両面印刷オフ
        this.userConfig.isPrintDoubleSides = false;
    }

    private printDoubleSides()
    {
        // 両面印刷オン
        this.userConfig.isPrintDoubleSides = true;
    }

    // ページの移動
    private goPage(page: number)
    {
        // アンドゥ・リドゥの対象外
        if (page < 0 || this.pageList.length <= page)
        {
            return;
        }
        this.currentDocument.currentPageIndex = page;
    }

    // 印刷部数変更
    private setPaperNumber(paperNumber: number)
    {
        this.paperNumber = paperNumber;
    }

    // 開始ページ変更
    private setPrintStartPage(page: number)
    {
        this.printStartPage = page;
    }

    // 終了ページ変更
    private setPrintEndPage(page: number) {
        this.printEndPage = page;
    }

    // 位置調整 : 縦
    private setVerticalPosition(position: number, isReverse = false)
    {
        if(isReverse)
        {
            this.userConfig.printVerticalPositionReverse = position;
        }
        else
        {
            this.userConfig.printVerticalPosition = position;
        }
    }

    // 位置調整 : 横
    private setHorizontalPosition(position: number, isReverse = false)
    {
        if(isReverse)
        {
            this.userConfig.printHorizontalPositionReverse = position;
        }
        else
        {
            this.userConfig.printHorizontalPosition = position;
        }
    }

    // 印刷倍率
    private setPrintRate(rate: number) 
    {
        this.userConfig.printRate = rate;
    }

    // 反転印刷
    private setPrintFlip(isFlip: boolean)
    {
        this.userConfig.isPrintFlip = isFlip;
    }

    // 枠あり印刷
    private setPrintBorderVisible(isVisible: boolean)
    {
        this.userConfig.isPrintBorder = isVisible;
    }

    // 印刷位置
    private changePrintVerticalDirection(direction : string, isReverse = false)
    {
        if(isReverse)
        {
            this.userConfig.printVerticalDirectionReverse = direction;
        }
        else
        {
            this.userConfig.printVerticalDirection = direction;
        }
    }
    private changePrintHorizontalDirection(direction : string, isReverse = false)
    {
        if(isReverse)
        {
            this.userConfig.printHorizontalDirectionReverse = direction;
        }
        else
        {
            this.userConfig.printHorizontalDirection = direction;
        }
    }

    // 枠色ピッカー表示
    private setVisibleBorderColorPicker(left, top) {
        // 位置設定
        this.pickerLeft = left;
        this.pickerTop = top;
        // 表示設定
        this.isBorderColorPickerVisible = true;
    }

    // 印刷可能切り替え
    private changePrintable()
    {
        var position = this.currentPage.currentDesignPosition;
        var isPrintable = this.currentPage.getSurface(this.isReverseSurface).isPrintable(position);
        this.currentPage.getSurface(this.isReverseSurface).setPrintable(position, !isPrintable);
    }

    // ズーム倍率変更
    private changeZoomScale(scale, isAutoZoomOff) {
        this.zoomScale = scale;

        // オートズーム解除
        if (isAutoZoomOff && this.isAutoZoom) {
            this.isAutoZoom = false;
        }
    }

    // 自動ズーム切り替え
    private changeAutoZoom(isAutoZoom) {
        this.isAutoZoom = isAutoZoom;
    }

    // レイアウトのページ数
    public get maxPage() : number
    {
        return this.pageList.length;
    }

    //** 印刷・pdf周りの処理 **//
    private isUpdatePreview = false; 
    private pdfPageIndex = 0;
    private layerIndex = 0;

    private renderPageIndex = 0;
    private renderIsReverse = false;
    private renderDesignPosition = 0;

    // SVG -> PDF
    private outputPageIndex = 0;
    private get outputPage() { return this.pageList[this.outputPageIndex]; }
    private isOutputReverseSurface = false;
    private arrayBufferArray = new Array();

    private createPdfFromPages(doPrint = false, code : string = "")
    {
        // レコメンド表示中は行わない
        if(this.loading) { return; }

        // ポップアップブロック回避のために空きページを作っておく
        //var win = doPrint ? window.open('', '_blank') : null;

        this.isUpdatePreview = true;

        // ローディング開始
        this.isCreatingPrintContent = true;
        this.isRunningPrintLoadingTimer = true;

        this.outputPageIndex = this.printStartPage - 1;
        this.isOutputReverseSurface = false;
        this.arrayBufferArray = new Array();
        this.createPdfFromPagesCore(() =>
        {
            var postData = {};
            postData["count"] = this.arrayBufferArray.length;
            var pages = "";
            var filenameArray = new Array();
            for(var i = 0; i < this.arrayBufferArray.length; ++i)
            {
                filenameArray.push("image" + (i + 1));
                pages += "" + (i + 1);
                if(i < this.arrayBufferArray.length - 1)
                {
                    pages += ",";
                }
            }
            postData["pages"] = pages;
            // サイズ指定
            var pageWidth = this.currentDocument.pageWidth;
            var pageHeight = this.currentDocument.pageHeight;
            if(MathHelper.equals(pageWidth, 148.5) && MathHelper.equals(pageHeight, 100))
            {
                pageWidth = 148;
            }
            else if(MathHelper.equals(pageHeight, 148.5) && MathHelper.equals(pageWidth, 100))
            {
                pageHeight = 148;
            }
            postData["sizeW"] = UnitHelper.convert(pageWidth, 'mm', 'px', 96);
            postData["sizeH"] = UnitHelper.convert(pageHeight, 'mm', 'px', 96);

            // 完了時処理
            var response = "";
            var isCompletionDone = false;
            var completion = () =>
            {
                try
                {
                    // mobileでの処置
                    if(doPrint)
                    {

                    }
                    else
                    {
                        // base64でデータを保持する
                        this.$store.getters.userConfig.exportedPDF = response;
                        // イベントを流す
                        var param = {};
                        if(code != "") { param["code"] = code; }
                        NativeHelper.sendNativeEvent("created_print_pdf", param);
                    }
                }
                catch(e)
                {
                    DebugHelper.trace(e);
                }
            };

            RequestHelper.postMultiBinary("svg_to_pdf", postData, this.arrayBufferArray, filenameArray, "image/svg+xml", (resp) =>
            {
                response = resp;

                // 作成中フラグを下ろす
                this.isCreatingPrintContent = false;

                // ローディング完了していれば完了処理
                if(!this.loading && !isCompletionDone)
                {
                    isCompletionDone = true;
                    completion();
                }
            },
            () =>
            {
                // ローディング終了
                this.isCreatingPrintContent = false;

                DebugHelper.trace("error");
            });

            // ローディングを指定時間でオフにするタイマー
            setTimeout(() =>
            {
                // 待ちフラグを落とす
                this.isRunningPrintLoadingTimer = false;

                // ローディング完了していれば完了処理
                if(!this.loading && !isCompletionDone)
                {
                    isCompletionDone = true;
                    completion();
                }

            },
            Const.PRINT_LOADING_MIN_MILLISECONDS);
        });
    }

    static readonly BASE64_MARKER = ';base64,';
    private createPdfFromPagesCore(completion : () => void)
    {
        this.$nextTick(() =>
        {
            if(this.isPrintable())
            {
                // SVGを取得する
                var preview = this.$refs.preview as PagePreview;
                var svgImage = preview.getSvgImage();
                var base64Idx = svgImage.indexOf(PrintSetting.BASE64_MARKER) + PrintSetting.BASE64_MARKER.length;
                var base64 = svgImage.substring(base64Idx);
                var raw = atob(base64);
                var rawLength = raw.length;
                var array = new Uint8Array(new ArrayBuffer(rawLength));
                for(var i = 0; i < rawLength; ++i)
                {
                    array[i] = raw.charCodeAt(i);
                }

                var buf = array.buffer as ArrayBuffer;
                this.arrayBufferArray.push(buf);
            }

            // 次
            if(this.outputPage.hasReverse && this.isOutputReverseSurface == false)
            {
                // 裏面
                this.isOutputReverseSurface = true;
                this.createPdfFromPagesCore(completion);
            }
            else if(this.outputPageIndex + 1 < this.printEndPage)
            {
                // 次のページ
                this.isOutputReverseSurface = false;
                this.outputPageIndex++;
                this.createPdfFromPagesCore(completion);
            }
            else
            {
                // 終了
                completion();
            }
        });
    }

    private isPrintable()
    {
        var result = false;
        if(this.isOutputReverseSurface)
        {
            // 裏面
            if(this.userConfig.isPrintDoubleSides || this.isReverseSurface)
            {
                // 両面印刷 or 裏面
                result = true;
            }
        }
        else
        {
            // 表面
            if(this.userConfig.isPrintDoubleSides || !this.isReverseSurface)
            {
                // 両面印刷　or 表面
                result = true;
            }
        }

        return result;
    }

    //選択中用紙
    get selectedPaper(){
        return this.$store.getters.data.selectedPaper
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }


    private closeLicense(){
        this.isLicense = false;
        this.isTutorial = CookieHelper.getItem("printSettingTutorial") != true;
    }
}

